import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import HeadingCp from '../components/HeadingCp';
import { NavLink, useParams, useNavigate } from 'react-router-dom';


const MaintenanceEstimatePage = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const [activeTab, setActiveTab] = useState('estimate');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [estimateData, setEstimateData] = useState({
    id: '',
    contact_name: '',
    contact_phone: '',
    contact_email: '',
    job_site: '',
    panel_type: '',
    system_type: '',
    dgp_qty: '',
    location: '',
    hourly_rate: '',
  });
  const { id } = useParams();
  const [devices, setDevices] = useState([]);
  const [config, setConfig] = useState(false);
  const [deviceRow, setDeviceRow] = useState({ device: '', qty: '', type: '1' }); // type: 1=input, 0=output



  useEffect(() => {
    if (id) {
      fetchEstimateData(id);
    }
  }, [id]);

  const fetchEstimateData = async (estimateId) => {
    setLoading(true);
    const response = await axios.get(`${apiUrl}/contracts_crud.php?getEstimateConfigs=true`);
    try {
      const response = await axios.get(`${apiUrl}/contracts_crud.php?getEstimateData=${id}`, {
        headers: { 'Content-Type': 'application/json'}
      });
      console.log(response.data, 'Fetched estimate data');
      
      if (response.data[0] === 'success') {
        const { estimate, devices, config } = response.data;
        setEstimateData(estimate);
        setDevices(devices);
        setConfig(config)
      } 
    } catch {
      toast.error('Error fetching estimate data');
    }
    setLoading(false);
  }

  const handleEstimateChange = (e) => {
    const { name, value } = e.target;
    setEstimateData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // --- Devices Handlers ---
  const handleDeviceInput = (e) => {
    const { name, value } = e.target;
    setDeviceRow((prev) => ({ ...prev, [name]: value }));
  };

  const addDevice = (e) => {
    e.preventDefault();
    if (!deviceRow.device || !deviceRow.qty) {
      toast.error('Device and quantity required');
      return;
    }
    setDevices((prev) => [
      ...prev,
      { ...deviceRow, id: Date.now() }, // Temp local id for UI
    ]);
    setDeviceRow({ device: '', qty: '', type: '1' });
  };

  const removeDevice = (id) => {
    setDevices((prev) => prev.filter((d) => d.id !== id));
  };

  // Save all devices (example API call - you can adjust to your backend)
  const handleSaveDevices = async () => {
    if (!estimateData.id) {
      toast.error('Please save the estimate first');
      return;
    }
    try {
    setLoading(true);

      // You'll need to send `maintenance_estimate_id` when editing!
      const response = await axios.post(`${apiUrl}/contracts_crud.php`, {
        status: 'saveEstimateDevices',
        data: devices.map(({ id, ...rest }) => rest), // strip local id before send
        maintenance_estimate_id: estimateData.id,
      });
      console.log(response.data, 'Response from saving devices');
      
      if (response.data.success) {
        toast.success('Devices saved!');
      } else {
        toast.error(response.data.error || 'Error saving devices');
      }
    } catch {
      toast.error('Error saving devices');
    }
    setLoading(false);
  };

  const handleEstimateSubmit = async (e) => {
    e.preventDefault();
    if (!estimateData.contact_name) {
      toast.error('Contact name and phone are required');
      return;
    }
    setLoading(true);
    try {
      const payload = {
        status: 'submitMaintenanceEstimate',
        data: estimateData,
      };
      console.log(payload, 'Payload for estimate submission');
      
      const response = await axios.post(`${apiUrl}/contracts_crud.php`, payload, {
        headers: { 'Content-Type': 'application/json' },
      });
      console.log(response.data, 'Response from estimate submission');
      if (response.data.success) {
        if(id === 'new') {
          navigate(`/maintenance_estimate/${response.data.id}`)
        }
        toast.success('Estimate saved!', { position: 'top-center' });
        // Optionally, save returned estimate ID for device links
        if (response.data.id) setEstimateData((prev) => ({ ...prev, id: response.data.id }));
      } else {
        toast.error(response.data.error || 'Error saving estimate', { position: 'top-center' });
      }
    } catch (error) {
      toast.error('Error saving estimate', { position: 'top-center' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 p-5">
      <div className="w-full max-w-3xl bg-white p-6 rounded-md shadow-md">
        <HeadingCp label="Maintenance Estimate" />
     <div className="mb-6 gap-3 flex">
        <NavLink to="/maintenance_es_list">
          <button
            type="button"
            className="px-4 py-2 border border-transparent text-sm font-medium rounded-md 
              shadow-sm text-white bg-green-400 hover:bg-green-700 focus:outline-none 
              focus:ring-2 focus:ring-offset-2 focus:ring-green-500">
               Estimate List
          </button>
        </NavLink>
      </div>

        {/* Tabs */}
        <div className="flex border-b mb-4 text-sm">
          <button
            onClick={() => setActiveTab('estimate')}
            className={`px-4 py-2 font-semibold ${
              activeTab === 'estimate'
                ? 'text-blue-600 border-b-2 border-blue-600'
                : 'text-gray-500'
            }`}
          >
            Estimate Info
          </button>
          <button
            onClick={() => setActiveTab('contact')}
            className={`ml-4 px-4 py-2 font-semibold ${
              activeTab === 'contact'
                ? 'text-blue-600 border-b-2 border-blue-600'
                : 'text-gray-500'
            }`}
          >
            Contact Info
          </button>
          <button
            onClick={() => setActiveTab('devices')}
            className={`ml-4 px-4 py-2 font-semibold ${
              activeTab === 'devices'
                ? 'text-blue-600 border-b-2 border-blue-600'
                : 'text-gray-500'
            }`}
          >
            Devices
          </button>
          <button
            onClick={() => setActiveTab('preview')}
            className={`ml-4 px-4 py-2 font-semibold ${
              activeTab === 'preview'
                ? 'text-green-600 border-b-2 border-green-600'
                : 'text-gray-500'
            }`}
          >
            Preview
          </button>          
        </div>

        {/* Estimate Info Tab */}
        {activeTab === 'estimate' && (
          <form onSubmit={handleEstimateSubmit} className="space-y-4">
            <div className="flex space-x-4">
              <div className="flex-1">
                <label className="block text-sm font-medium text-gray-700">Job Site <span className='text-red-500'>*</span></label>
                <input
                  type="text"
                  name="job_site"
                  value={estimateData.job_site}
                  onChange={handleEstimateChange}
                  required
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm sm:text-sm"
                />
              </div>
              <div className="flex-1">
                <label className="block text-sm font-medium text-gray-700">Panel Type <span className='text-red-500'>*</span></label>
                <input
                  type="text"
                  name="panel_type"
                  value={estimateData.panel_type}
                  onChange={handleEstimateChange}
                  required
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm sm:text-sm"
                />
              </div>
              <div className="flex-1">
                <label className="block text-sm font-medium text-gray-700">System Type <span className='text-red-500'>*</span></label>
                <input
                  type="text"
                  name="system_type"
                  value={estimateData.system_type}
                  onChange={handleEstimateChange}
                  required
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm sm:text-sm"
                />
              </div>
            </div>
            <div className="flex space-x-4">
              <div className="flex-1">
                <label className="block text-sm font-medium text-gray-700">DGP Qty</label>
                <input
                  type="number"
                  name="dgp_qty"
                  value={estimateData.dgp_qty}
                  onChange={handleEstimateChange}
                  min="0"
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm sm:text-sm"
                />
              </div>
              <div className="flex-1">
                <label className="block text-sm font-medium text-gray-700">Location</label>
                <input
                  type="text"
                  name="location"
                  value={estimateData.location}
                  onChange={handleEstimateChange}
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm sm:text-sm"
                />
              </div>
              <div className="flex-1">
                <label className="block text-sm font-medium text-gray-700">Hourly Rate</label>
                <input
                  type="number"
                  step="0.01"
                  name="hourly_rate"
                  value={estimateData.hourly_rate}
                  onChange={handleEstimateChange}
                  min="0"
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm sm:text-sm"
                />
              </div>
            </div>
            <div className="mt-6 flex justify-end space-x-2">
              <button
                type="submit"
                disabled={loading}
                className="inline-flex justify-center rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700 focus:outline-none"
              >
                {loading ? 'Saving...' : 'Save'}
              </button>
            </div>
          </form>
        )}

        {/* Contact Info Tab */}
        {activeTab === 'contact' && (
          <form className="space-y-6">
            <div className="flex space-x-4">
              <div className="flex-1">
                <label className="block text-sm font-medium text-gray-700">Contact Name <span className='text-red-500'>*</span></label>
                <input
                  type="text"
                  name="contact_name"
                  value={estimateData.contact_name}
                  onChange={handleEstimateChange}
                  required
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm sm:text-sm"
                />
              </div>
              <div className="flex-1">
                <label className="block text-sm font-medium text-gray-700">Contact Phone <span className='text-red-500'>*</span></label>
                <input
                  type="number"
                  name="contact_phone"
                  value={estimateData.contact_phone}
                  onChange={handleEstimateChange}
                  required
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm sm:text-sm"
                />
              </div>
              <div className="flex-1">
                <label className="block text-sm font-medium text-gray-700">Contact Email</label>
                <input
                  type="email"
                  name="contact_email"
                  value={estimateData.contact_email}
                  onChange={handleEstimateChange}
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm sm:text-sm"
                />
              </div>
            </div>
          </form>
        )}

        {/* Devices Tab */}
        {activeTab === 'devices' && (
          <div>
            <form onSubmit={addDevice} className="flex space-x-2 mb-4">
              <input
                type="text"
                name="device"
                placeholder="Device Name"
                value={deviceRow.device}
                onChange={handleDeviceInput}
                className="border rounded p-2 flex-1"
                required
              />
              <input
                type="number"
                name="qty"
                placeholder="Qty"
                value={deviceRow.qty}
                onChange={handleDeviceInput}
                min="1"
                className="border rounded p-2 w-24"
                required
              />
              <select
                name="type"
                value={deviceRow.type}
                onChange={handleDeviceInput}
                className="border rounded p-2 w-28"
                required
              >
                <option value="1">Input</option>
                <option value="0">Output</option>
              </select>
              <button
                type="submit"
                className="bg-green-600 text-white px-3 py-2 rounded hover:bg-green-700"
              >
                Add Device
              </button>
            </form>

            <div className="overflow-x-auto border rounded shadow">
              <table className="min-w-full text-sm">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="p-2 text-left">Device</th>
                    <th className="p-2 text-left">Qty</th>
                    <th className="p-2 text-left">Type</th>
                    <th className="p-2 text-left">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {devices.map((device) => (
                    <tr key={device.id} className="border-t">
                      <td className="p-2">{device.device}</td>
                      <td className="p-2">{device.qty}</td>
                      <td className="p-2">{device.type === '1' ? 'Input' : 'Output'}</td>
                      <td className="p-2">
                        <button
                          className="text-red-600 hover:underline"
                          onClick={() => removeDevice(device.id)}
                        >
                          Remove
                        </button>
                      </td>
                    </tr>
                  ))}
                  {devices.length === 0 && (
                    <tr>
                      <td className="p-2 text-gray-400" colSpan={4}>
                        No devices added yet.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div className="flex justify-end mt-4">
              <button
                onClick={handleSaveDevices}
                disabled={loading}
                className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
              >
                {loading ? 'Saving...' : 'Save Devices'}
              </button>
            </div>
          </div>
        )}

        {activeTab === 'preview' && (
          <div>
            <h2 className="text-lg font-semibold mb-4 text-green-700">Preview: Estimate Info</h2>
            <div className="bg-gray-50 p-4 rounded mb-6">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <div className="font-bold">Job Site:</div>
                  <div>{estimateData.job_site}</div>
                </div>
                <div>
                  <div className="font-bold">Panel Type:</div>
                  <div>{estimateData.panel_type}</div>
                </div>
                <div>
                  <div className="font-bold">System Type:</div>
                  <div>{estimateData.system_type}</div>
                </div>
                <div>
                  <div className="font-bold">DGP Qty:</div>
                  <div>{estimateData.dgp_qty}</div>
                </div>
                <div>
                  <div className="font-bold">Location:</div>
                  <div>{estimateData.location}</div>
                </div>
                <div>
                  <div className="font-bold">Hourly Rate:</div>
                  <div>{estimateData.hourly_rate}</div>
                </div>
                <div>
                  <div className="font-bold">Contact Name:</div>
                  <div>{estimateData.contact_name}</div>
                </div>
                <div>
                  <div className="font-bold">Contact Phone:</div>
                  <div>{estimateData.contact_phone}</div>
                </div>
                <div>
                  <div className="font-bold">Contact Email:</div>
                  <div>{estimateData.contact_email}</div>
                </div>
              </div>
            </div>

            <h2 className="text-lg font-semibold mb-4 text-green-700">Preview: Devices</h2>
            <div className="overflow-x-auto border rounded shadow">
              <table className="min-w-full text-sm">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="p-2 text-left">Device</th>
                    <th className="p-2 text-left">Qty</th>
                    <th className="p-2 text-left">Min/per device</th>
                    <th className="p-2 text-left">Total</th>
                    <th className="p-2 text-left">Type</th>
                  </tr>
                </thead>
                <tbody>
                  {devices.length === 0 ? (
                    <tr>
                      <td className="p-2 text-gray-400" colSpan={5}>No devices added yet.</td>
                    </tr>
                  ) : (
                    devices.map((device, idx) => (
                      <tr key={device.id || idx}>
                        <td className="p-2">{device.device}</td>
                        <td className="p-2">{device.qty}</td>
                        <td className="p-2">
                          {device.type === 1
                            ? config?.min_per_input
                            : config?.min_per_output}
                        </td>
                        <td className="p-2">
                          {device.type === 1
                            ? (config?.min_per_input || 0) * device.qty
                            : (config?.min_per_output || 0) * device.qty}
                        </td>
                        <td className="p-2">{device.type === 1 ? 'Input' : 'Output'}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            {/* --- Summary Row --- */}
            {devices.length > 0 && (
              <div className="bg-gray-50 border-t py-4 flex flex-col sm:flex-row gap-4 mt-2">
                <div className="font-semibold text-gray-700 text-sm">
                  Total Devices:{" "}
                  <span className="text-blue-700 font-bold">
                    {devices.reduce((sum, d) => sum + Number(d.qty), 0)}
                  </span>
                </div>
                <div className="font-semibold text-gray-700 text-sm">
                  Total Minutes:{" "}
                  <span className="text-green-700 font-bold">
                    {devices.reduce(
                      (sum, d) =>
                        sum +
                        (d.type === 1
                          ? (config?.min_per_input || 0) * Number(d.qty)
                          : (config?.min_per_output || 0) * Number(d.qty)),
                      0
                    )}
                  </span>
                </div>
                <div className="font-semibold text-gray-700 text-sm">
                  Total Price:&nbsp;
                  <span className="text-orange-700 font-bold">
                    {(() => {
                      const totalMinutes = devices.reduce(
                        (sum, d) =>
                          sum +
                          (d.type === 1
                            ? (config?.min_per_input || 0) * Number(d.qty)
                            : (config?.min_per_output || 0) * Number(d.qty)),
                        0
                      );
                      const hourlyRate = Number(estimateData.hourly_rate) || 0;
                      // Price = (totalMinutes / 60) * hourly_rate
                      return `$${((totalMinutes / 60) * hourlyRate).toLocaleString(undefined, {minimumFractionDigits:2, maximumFractionDigits:2})}`;
                    })()}
                  </span>
                </div>
              </div>
            )}
          </div>
        )}

      </div>
    </div>
  );
};

export default MaintenanceEstimatePage;
